import {
  IFRAME_SOURCE_ID,
  IFRAME_ACTION_CLOSE,
  IFRAME_ACTION_ANALYTICS,
  SPORTCALLER_ANALYTICS_EVENT,
  PAGEVIEW_ANALYTICS_EVENT,
  IFRAME_ACTION_ADDTOSLIP,
} from '../constants';
import { track } from '@sb/analytics-adapter/src/client';
import { getMessageBus } from '../apis';
import topics from '../apis/topics';

/*
  Type definitions
 */
type CloseActionType = 'close';
type AnalyticsActionType = 'analytics';
type AddToSlipActionType = 'addToSlip';

type DataType = {
  source: string;
  action: CloseActionType | AnalyticsActionType | AddToSlipActionType;
  payload: any;
};
type EventType = {
  data: DataType;
  origin: string;
};

type AddToSlipPayload = {
  id: string;
  priceType: 'FIXED_ODDS';
  analytics: {
    FeatureDescription: 'SOTD';
  };
};

/*
  Close Handler
 */
export function close(): void {
  location.hash = '';
}

function analytics(data: any): void {
  const { EventCategory } = data;

  const payload = { ...data, ProductContext: 'SportCaller' };
  const event = !!EventCategory ? SPORTCALLER_ANALYTICS_EVENT : PAGEVIEW_ANALYTICS_EVENT;

  track({
    event,
    payload,
  });
}

function addToSlip(payload: AddToSlipPayload): void {
  const messageBus = getMessageBus();
  const { id } = payload;

  if (messageBus) {
    messageBus.publish(topics.ADDTOSLIP, { ...payload, id: id.replace('OB_OU', '') });
  }
}

/*
  postMessage handler dispatcher
 */
export default ({ data, origin }: EventType): void => {
  const { source, action, payload } = data;
  const eventOrigin = new URL(origin).origin;
  const iframeOrigin = new URL(process.env.IFRAME_SRC || '').origin;

  if (eventOrigin !== iframeOrigin || source !== IFRAME_SOURCE_ID) {
    return;
  }

  switch (action) {
    case IFRAME_ACTION_CLOSE:
      close();
      break;
    case IFRAME_ACTION_ANALYTICS:
      analytics(payload);
      break;
    case IFRAME_ACTION_ADDTOSLIP:
      addToSlip(payload);
      break;
  }
};
